import { Wrapper } from './styles';
import { ScreenHeadingProps } from './types';

const ScreenHeading = ({ children, alignment, marginBottom, hasBorder = false }: ScreenHeadingProps) => {
	return (
		<Wrapper $hasBorder={hasBorder} $alignment={alignment} $marginBottom={marginBottom} tabIndex={-1}>
			{children}
		</Wrapper>
	);
};

export default ScreenHeading;
